export default __webpack_public_path__ + "static/media/audio_25_mosquito.c8a1e58e.mp3";